import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAttribution, nowISO } from "@/hooks/useAttribution";
import { useFormTimer } from "@/hooks/useFormTimer";
import Honeypot from "@/components/Honeypot";

export default function Footer() {
  const attribution = useAttribution();
  const { elapsedMs } = useFormTimer();
  const [hp, setHp] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [done, setDone] = React.useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", {
        email,
        attribution,
        submitted_at: nowISO(),
        time_to_complete_ms: elapsedMs(),
        company_website_alt: hp,
      });
      setDone(true);
    } catch (err) {
      // Newsletter signup failures are non-blocking by design.
      void err;
    }
  };
  return (
    <footer className="bg-base border-t border-white/5 mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="https://customer-assets.emergentagent.com/job_creative-freedom-ai-1/artifacts/xmezblsi_Logo.jpeg" alt="Freedom By AI Design" className="h-20 w-auto"/>
          <p className="text-secondary mt-6 max-w-md leading-relaxed">Luxury AI consulting from Denver, Colorado. We design AI systems for businesses that refuse to miss another lead.</p>
          <form onSubmit={submit} className="mt-8 max-w-md">
            <Honeypot value={hp} onChange={setHp}/>
            <label className="overline block mb-3">Receive the dispatch</label>
            <div className="flex gap-3 items-end">
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="your@email.com" className="input-line flex-1" data-testid="footer-newsletter-input"/>
              <button type="submit" className="btn-ghost" data-testid="footer-newsletter-submit">{done ? "Subscribed ✓" : "Subscribe →"}</button>
            </div>
          </form>
        </div>
        <div className="md:col-span-3">
          <div className="overline mb-5">Explore</div>
          <ul className="space-y-3 text-secondary">
            <li><Link to="/#solutions" className="hover:text-primary transition">Solutions</Link></li>
            <li><Link to="/#industries" className="hover:text-primary transition">Industries</Link></li>
            <li><Link to="/#pricing" className="hover:text-primary transition">Pricing</Link></li>
            <li><Link to="/#demo" className="hover:text-primary transition">Demo Center</Link></li>
            <li><Link to="/#roi" className="hover:text-primary transition">ROI Calculator</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline mb-5">Company</div>
          <ul className="space-y-3 text-secondary">
            <li><Link to="/#about" className="hover:text-primary transition">About</Link></li>
            <li><Link to="/#cases" className="hover:text-primary transition">Case Studies</Link></li>
            <li><Link to="/#faq" className="hover:text-primary transition">FAQ</Link></li>
            <li><Link to="/affiliate" className="hover:text-primary transition">Affiliates</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline mb-5">Contact</div>
          <ul className="space-y-3 text-secondary">
            <li>Denver, CO</li>
            <li><a href="mailto:freedombyaidesign@gmail.com" className="hover:text-primary transition">freedombyaidesign@gmail.com</a></li>
            <li><a href="tel:7204194164" className="hover:text-primary transition" data-testid="footer-phone-link">(720) 419-4164</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs text-muted tracking-widest uppercase">© {new Date().getFullYear()} Freedom By AI Design</div>
          <div className="text-xs text-muted tracking-widest uppercase">Designed in Denver · Built for Founders</div>
        </div>
      </div>
    </footer>
  );
}
